import React from "react";
import {
  Box,
  Flex,
  Text,
  useMediaQuery,
} from "@chakra-ui/react";
import Project from "./Project";

function Projects() {
  const [isNotSmall] = useMediaQuery("(min-width: 1100px)");
  const [isNotSuperSmall] = useMediaQuery("(min-width: 900px)");
  const [isNotUltraSmall] = useMediaQuery("(min-width: 750px)");
  return (
     <div
      style={
        { display: "flex" ,justifyContent:'center'}
          
      }
      id="projects"
    >
      <Flex
      
        direction={"column"}

        alignItems={"center"}


      >
        <Text
        margin={10}
            fontSize={isNotSmall ? "5xl" : "4xl"}
            fontWeight={"thin"}
            bgGradient={"linear(to-r,teal.400, cyan.400)"}
            bgClip={"text"}
          >
            {"Projects"}
          </Text>
        <Box margin={'20px'} pl={'20'} pr={'12px'}  display={'flex'} width={'100vw'} alignItems={'center'} flexWrap={isNotSmall ? 'wrap' : 'nowrap'}   justifyContent={'center'} gap={'40px'} flexDirection={isNotSmall ? 'row':'column'}>
          <Project
              src="poro2.png"
              title="Porosheets.com"
              lang="NextJS"
              description="A fun and engaging discord bot with instructions on how to reuse on any server"
              link="https://github.com/hamza-al/discord-bot"
            />
            <Project
              src="image.png"
              title="Snippetsnap"
              lang="NextJS"
              description="A website that allows the creation of typewriter animations of code files"
              link="snippetsnap.vercel.com"
            />  

            <Project
              src="beepss.png"
              title="beep."
              lang="C# / Unity"
              description="'beep.' is a 2-d top down shooter game created from scratch in the Godot game engine then migrated to C#."
              private={true}
            />
            <Project
              src="hands.jpg"
              title="Helping Hand"
              lang="Flutter / Dart"
              description="Helping Hands is a mobile application for both providing and finding services. "
              private={true}
            />
            <Project
              src="rally.png"
              title="Rallyfind"
              lang="Flutter / Dart"
              description="Rallyfind is a mobile application that allows people to find events relating to causes they stand for "
              link="https://apps.apple.com/us/app/rallyfind/id6503272548"
            />
             <Project
              src="HA2.png"
              title="Personal portfolio"
              lang="JavaScript /React / Chakra UI"
              description="Personal Portfolio (the website you see right now :)) made in React JS with Chakra UI  "
              private={true}
            />
 
        </Box>        
      </Flex>

      {/* {isNotVerySmall ? <Box
        style={isNotSmall ? { width: "500px", backgroundColor:'red'} : { width: 250 }}
        m={!isNotSmall ? 10 : 10}
      >
        
      </Box> : null} */}
    </div>
  );
}

export default Projects;
